module.exports = __webpack_public_path__ + "static/media/mail.567c4599.svg";